import { Tabs } from 'antd';
import styled from 'styled-components';

export const TabsWrapper = styled(Tabs)<{
  borderColor?: string;
  isHideTab: boolean;
}>`
  .ant-tabs-tab-active .quantity,
  &:is(.ant-tabs-top, .ant-tabs-bottom) .quantity {
    background: white;
    color: var(--primary);
  }

  &:is(.ant-tabs-top, .ant-tabs-bottom) .ant-tabs-tab-active .quantity {
    background: var(--primary);
    color: white;
  }

  &.ant-tabs-middle .quantity {
    height: 20px;
    min-width: 26px;

    font-size: 12px;
  }

  &.ant-tabs-small .quantity {
    height: 16px;
    min-width: 22px;

    font-size: 10px;
  }

  &:is(.ant-tabs-top, .ant-tabs-bottom) .ant-tabs-tab-disabled .quantity {
    color: rgba(0, 0, 0, 0.25);
  }

  &:is(.ant-tabs-left, .ant-tabs-right) .ant-tabs-tab-disabled .quantity {
    color: rgba(0, 0, 0, 0.25);
    background-color: var(--light-pink);
  }

  &:is(.ant-tabs-top, .ant-tabs-bottom) .ant-tabs-nav-list {
    border-bottom: 1px solid ${p => p.borderColor};
    display: ${p => (p.isHideTab ? 'none' : '')};
  }
`;

export const TabWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  .quantity {
    height: 24px;
    min-width: 32px;
    border-radius: 2px;

    color: white;
    background: var(--primary);
    font-size: 14px;

    display: flex;
    align-items: center;
    justify-content: center;

    transition: all 0.1s ease;
  }
`;
